import { faBabyCarriage, faBook, faChalkboardUser, faLaptopCode, faPersonSkating, faShieldVirus } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import FacilitiesCard from './FacilitiesCard';
import building from '../../assets/images/building-2.jpg';

const facilitiesData = [
    {
        "_id": "1",
        "title": "Accommodation",
        "icon": faShieldVirus,
        "description": "ICE provides comfortable hostel accommodations for over 750 students, featuring two boys' hostels and one girls' hostel. Each hostel offers Wi-Fi, laundry services, dining facilities, and indoor games for a convenient living experience."
    },
    {
        "_id": "2",
        "title": "Lab Facility",
        "icon": faBabyCarriage, 
        "description": "Students gain practical knowledge in various laboratories, including Software Lab, Hardware Lab, PLC HMI & SCADA Trainer, Mechanical Workshop, Electrical & Electronics Lab, and Textile Lab, enhancing their technical skills through hands-on experience."
    },
    {
        "_id": "3",
        "title": "Library",
        "icon": faBook,
        "description": "The ICE library boasts a collection of over 1,000 books, journals, and research papers, continually expanding its resources to support students and researchers with updated and diverse academic materials."
    },
    {
        "_id": "4",
        "title": "Club",
        "icon": faLaptopCode,
        "description": "Students can join various clubs, including Cultural, Sports, Language, and Career Clubs, to explore interests, develop skills, and connect with peers through artistic, athletic, linguistic, and professional activities."
    },
    {
        "_id": "5",
        "title": "Blended Learning Platform",
        "icon": faChalkboardUser,
        "description": "To enhance student engagement beyond face-to-face classes, our faculty members and students collaborate through online platforms, fostering interactive learning, discussions, and academic support in a flexible digital environment."
    },
    {
        "_id": "6",
        "title": "Extracurricular Activities",
        "icon": faPersonSkating,
        "description": "To ensure the mental and physical well-being of students and employees, we provide a well-equipped gymnasium with modern fitness facilities, encouraging a healthy and active lifestyle."
    }
];

const Facilities = () => {
    return (
        <div className='my-24  container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 font-poppins'>
            <div className='lg:col-span-2  md:col-span-2 text-center md:text-left'>
                <h1 className='text-4xl font-bold text-secondary pb-4'>What we<span className='text-primary'> Offer</span></h1>
                <p className='text-center md:text-left text-lg'>At <span className='text-primary font-bold'>Imperial College of Engineering</span>, students get the opportunity to think, learn, and grow.</p>

                <div className=' grid grid-cols-1 sm:grid-cols-2 gap-6 justify-items-center md:justify-items-start'>
                    {
                        facilitiesData.map(data => <FacilitiesCard key={data._id} data={data} />)
                    }
                </div>
            </div>
            <div className='hidden lg:flex justify-end'>
                <img className='h-auto max-w-full rounded-lg shadow-lg' src={building} alt="campus" />
            </div>
        </div>
    );
};

export default Facilities;
